import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import FullCalendar from '@fullcalendar/react';
import timeGridPlugin from '@fullcalendar/timegrid';
import moment from 'moment';
import React, { useContext, useState } from 'react';
import { ListGroup, Modal } from 'react-bootstrap';
import { withTranslation ,useTranslation} from "react-i18next";
import { LoaderContext } from '../../../App';
import CalendarEventService from '../../../core/service/CalendarEventService';
import './OrgCalendar.scss';
import OrganizationCalendarModal from './OrganizationCalendarModal';
import multiMonthPlugin from '@fullcalendar/multimonth'

const OrganizationCalendar = ({ t }) => {

	const { setLoaderDisplay } = useContext(LoaderContext);
	const [events, setEvents] = useState([]);
	const [selectedEventId, setSelectedEventId] = useState(null);
	const [calendarConfig, setCalendarConfig] = useState({
		view: {
			type: '',
			currentStart: null,
			currentEnd: null
		}
	});
	const [activeMonthEvents, setActiveMonthEvents] = useState([]);
	const { k, i18n } = useTranslation();

	const getEventsInRange = (startDate, endDate) => {
		setLoaderDisplay(true);
		CalendarEventService.getRangeOfEvents(startDate, endDate).then(res => {
			if (res.status !== 200) return;

			setLoaderDisplay(false);

			const transformedEvents = [];
			res.data?.map(event => {
				const transformedEvent = {
					id: event.id ?? Date.now(),
					altId: event.id,
					title: `${event.customAttributes.formName} - ${event.id ? moment(event.occurrenceDate).format("MMMM, YYYY") : moment(event.startDate).format("MMMM, YYYY")}`,
					start: event.occurrenceDate,
					end: `${event.occurrenceDate}T23:59:59`,
					description: event.type,
					extendedProps: event.customAttributes,
					allDay: true,
					frequency: event.frequency
				};
				transformedEvents.push(transformedEvent);
			});
			setEvents(transformedEvents);
		}).catch(err => {
			setLoaderDisplay(false);
		});
	}

	const handleEventClick = (clickedEvent) => {
		setSelectedEventId(clickedEvent.event.extendedProps.altId);
	}

	/* The following lines of code are commented out for future use — Grid Year View */

	// const handleYearEventClick = (clickedEvent) => {
	// 	setSelectedEventId(clickedEvent.id);
	// }

	// const handleMoreClick = (events) => {
	// 	setActiveMonthEvents(events);
	// };

	// const handleCloseModal = () => {
	// 	setActiveMonthEvents([]);
	// };

	const handleDatesSet = (info) => {
		setEvents([]);
		setCalendarConfig({
			view: {
				type: info.view.type,
				currentStart: info.view.currentStart,
				currentEnd: info.view.currentEnd
			}
		});

		let start, end;
		if (info.view.type === 'dayGridMonth') {
			start = moment(info.view.currentStart).startOf('month').format('YYYY-MM-DD');
			end = moment(info.view.currentStart).endOf('month').format('YYYY-MM-DD');
			getEventsInRange(start, end);
		} else if (info.view.type === 'timeGridWeek') {
			start = moment(info.view.currentStart).format('YYYY-MM-DD');
			end = moment(info.view.currentEnd).format('YYYY-MM-DD');
			getEventsInRange(start, end);
		} else if (info.view.type === 'multiMonthYear') {
			start = moment(info.view.currentStart).startOf('year').format('YYYY-MM-DD');
			end = moment(info.view.currentStart).endOf('year').format('YYYY-MM-DD');
			getEventsInRange(start, end);
		}
	};

	/* The following lines of code are commented out for future use — Grid Year View */

	// const renderYearGrid = (info) => {
	// 	const currentYear = new Date(info.dateProfile.currentDate).getFullYear();

	// 	const months = Array.from({ length: 12 }, (_, i) => {
	// 		const monthIndex = (i + 1).toString().padStart(2, '0');
	// 		const date = new Date(new Date().getFullYear(), i, 1);

	// 		const eventsForMonth = transformEvents().filter(event => {
	// 			const eventDate = new Date(event.start);
	// 			const eventYear = eventDate.getFullYear();
	// 			const eventMonth = (eventDate.getMonth() + 1).toString().padStart(2, '0');

	// 			return eventYear === currentYear && monthIndex === eventMonth;
	// 		});
	// 		return (
	// 			<div key={i} className="year-grid-item">
	// 				<div className="year-grid-head">
	// 					<strong>{date.toLocaleString('default', { month: 'long' })}</strong>
	// 				</div>
	// 				<div className="year-grid-body">
	// 					{
	// 						<ListGroup>
	// 							{eventsForMonth.slice(0, 2).map((event, index) => (
	// 								<div className='mb-1'>

	// 									<ListGroup.Item key={index} className="list-group-item-action custom-cursor-pointer p-1"
	// 										onClick={() => handleYearEventClick(event)}>
	// 										<span>{event.title}</span>
	// 									</ListGroup.Item>
	// 								</div>
	// 							))}
	// 						</ListGroup>
	// 					}


	// 				</div>

	// 				{
	// 					eventsForMonth.length > 2 && (
	// 						<div className='year-grid-footer' onClick={() => handleMoreClick(eventsForMonth)}>
	// 							<span>+{eventsForMonth.length - 2} more</span>
	// 						</div>
	// 					)
	// 				}
	// 			</div>
	// 		);
	// 	});

	// 	return <div className="year-grid">{months}</div>;
	// };




	// const renderEventsListModal = () => {
	// 	return (
	// 		<Modal
	// 			show={true}
	// 			onHide={handleCloseModal}
	// 			size="md"
	// 			aria-labelledby="contained-modal-title-vcenter"
	// 			centered>
	// 			<Modal.Header className="bg-white" closeButton>
	// 				< Modal.Title as="h5">
	// 					{t("YearEvents.label")} {new Date(activeMonthEvents[0]?.start).toLocaleString('default', { month: 'long' })}
	// 				</Modal.Title>
	// 			</Modal.Header>
	// 			<Modal.Body>
	// 				{
	// 					<ListGroup>
	// 						{activeMonthEvents.map((event, index) => (
	// 							<div className='mb-2'>
	// 								<ListGroup.Item key={index} className="list-group-item-action custom-cursor-pointer"
	// 									onClick={() => handleYearEventClick(event)}>
	// 									<span>{event.title}</span>
	// 									<span className='d-none'>{event.frequency}</span>
	// 								</ListGroup.Item>
	// 							</div>
	// 						))}
	// 					</ListGroup>
	// 				}
	// 			</Modal.Body>
	// 		</Modal>
	// 	)
	// }

	return (
		<div className='mt-3 FullCalendar_Card'>
			<FullCalendar
				plugins={[multiMonthPlugin, timeGridPlugin, interactionPlugin]}
				initialView="multiMonthYear"
				locale={i18n.language}
				headerToolbar={{
					start: 'today prev,next',
					center: 'title',
					// end: 'customYearView,dayGridMonth,timeGridWeek'
					// end: 'multiMonthYear,dayGridMonth,timeGridWeek'
					end: 'multiMonthYear,timeGridWeek'
				}}
				buttonText={{
					today: t("Today.label"),
					// month: 'Month',
					week: t("Week.label"),
					year: t("Month.label")
				}}
				eventMouseEnter={(mouse) => {
					if (mouse.event.extendedProps.altId) {
						mouse.el.style.cursor = 'pointer';
						mouse.el.title = mouse.event.title;
					}
				}}
				multiMonthMaxColumns={1}
				events={events}
				eventClick={handleEventClick}
				datesSet={handleDatesSet}
			// views={{
			// 	customYearView: {
			// 		type: 'dayGrid',
			// 		buttonText: 'Year',
			// 		duration: { years: 1 },
			// 		content: renderYearGrid,
			// 	},
			// }}
			/>

			{
				selectedEventId &&
				<OrganizationCalendarModal
					eventId={selectedEventId}
					onCloseCallback={() => { setSelectedEventId(null); }}
					onUpdate={() => { handleDatesSet(calendarConfig); setSelectedEventId(null); setActiveMonthEvents([]); }}
				/>
			}

			{/* The following lines of code are commented out for future use — Grid Year View  */}

			{/* {
				activeMonthEvents.length > 0 &&
				renderEventsListModal()
			} */}
		</div>
	);
}

export default withTranslation()(OrganizationCalendar);